const getEnvValue = (value: unknown): string | undefined => {
  if (typeof value !== 'string') {
    return undefined
  }

  const trimmedValue = value.trim()
  return trimmedValue || undefined
}

const whmcsRoot = getEnvValue(process.env.WHMCS_ROOT) ?? '/cloud'
const normalizedWhmcsRoot = whmcsRoot.replace(/\/+$/, '')
export const WHMCS_ROOT: string =
  normalizedWhmcsRoot === '' ||
  /^https?:\/\//i.test(normalizedWhmcsRoot) ||
  normalizedWhmcsRoot.startsWith('/')
    ? normalizedWhmcsRoot
    : `/${normalizedWhmcsRoot}`

const newApiEndpoint = getEnvValue(process.env.WHMCS_NEW_API)
const rawApiEndpoint: string =
  newApiEndpoint ??
  getEnvValue(process.env.WHMCS_API) ??
  `${WHMCS_ROOT}/custom/api.php`

const normalizedApiEndpoint = rawApiEndpoint.replace(/\/+$/, '')
export const API_ENDPOINT: string = newApiEndpoint
  ? normalizedApiEndpoint.replace(/\/api\.php$/, '/api')
  : normalizedApiEndpoint
const appendRoot = (url: string) => {
  const normalizedPath = url.startsWith('/') ? url : `/${url}`
  return `${WHMCS_ROOT}${normalizedPath}`
}

export const URL_CONF_PRODUCT = appendRoot('cart.php?a=confproduct')
export const URL_ADD_PRODUCT = appendRoot('cart.php?a=add')
export const URL_ADD_PRODUCT_WITH_DOMAIN = appendRoot(
  'cart.php?a=add&domainselect=1'
)
export const URL_UPDATE_DOMAIN_PERIOD = appendRoot(
  'cart.php?a=updateDomainPeriod'
)
export const URL_CONF_DOMAIN = appendRoot('cart.php?a=confdomains')
export const URL_CHECK_DOMAIN = appendRoot('index.php?rp=/domain/check')
